module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("3Ohz9"))).then(() => parcelRequire('5erN3'));